import { Component } from '@angular/core';

@Component({
  selector: 'comp-auth-completed',
  templateUrl: 'authentication-completed.component.html',
})
export class AuthenticationCompletedComponent {}
